module.exports = __webpack_public_path__ + "img/1551768207022415873.129e79d7.jpg";